<h2 mat-dialog-title class="dialog-title">
  {{ data.mode === 'create' ? 'Neuer Textbaustein' : 'Textbaustein bearbeiten' }}
</h2>

<mat-dialog-content class="mat-typography dialog-content">
  <!-- Loading indicator -->
  <div *ngIf="loading" class="loading-container">
    <p>Lade Daten...</p>
  </div>

  <form [formGroup]="templateForm" *ngIf="!loading">
    <!-- Schlüsselwort -->
    <div class="form-group">
      <label class="form-label" for="schluesselwort">Schlüsselwort *</label>
      <input
        type="text"
        id="schluesselwort"
        formControlName="schluesselwort"
        maxlength="100"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="z.B. Köderbox aufgefüllt" />
    </div>

    <!-- Text -->
    <div class="form-group">
      <label class="form-label" for="text">Text *</label>
      <textarea
        id="text"
        formControlName="text"
        rows="5"
        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Textbaustein, der in die Anmerkungen eingefügt wird"></textarea>
    </div>

    <!-- Sortierung -->
    <div class="form-group">
      <label class="form-label" for="sortierung">Sortierung *</label>
      <input
        type="number"
        id="sortierung"
        formControlName="sortierung"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Sortierung" />
    </div>

    <!-- Status ID -->
    <div class="form-group">
      <label class="form-label" for="status_id">Status ID *</label>
      <input
        type="number"
        id="status_id"
        formControlName="status_id"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Status ID (1 = aktiv, 0 = inaktiv)" />
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 16px 24px;">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button mat-button (click)="onSubmit()" cdkFocusInitial>Speichern</button>
</mat-dialog-actions>
